import * as types from './actionTypes';
import activityService from '../services/activityService';
import { fetch, addTask } from 'domain-task';
import moment from 'moment';

export function getActivityFeed() {
    return (dispatch, getState) => {
        const activity = getState().activity;
        if(activity.activityFeed.length === 0 || !activity.lastLoaded || activity.lastLoaded < moment().subtract(1, 'minutes')) {        
            dispatch({ type: types.CLEAR_ACTIVITY_FEED });
            dispatch({ type: types.GET_ACTIVITY_FEED_STATUS, loadingStatus: {status: 'LOADING'} });
            let fetchTask = activityService.getActivityFeed()
                .then(activityFeed => {
                    if(activityFeed) {
                        dispatch({ type: types.GET_ACTIVITY_FEED, activityFeed });
                        dispatch({ type: types.GET_ACTIVITY_FEED_STATUS, loadingStatus: {status: 'LOADED'} });
                    }
                    return activityFeed;
                })
                .catch(error => {
                    dispatch({ type: types.GET_ACTIVITY_FEED_STATUS, loadingStatus: {status: 'FAILED'} });
                });
            addTask(fetchTask);
        }
    };
}